const CompareHelper = {
  // new merge table function

  compareOrigAndIqcio: (orig_data, iqcio_data) => {
    if (orig_data && iqcio_data) {
      // orig data
      var mergedData = [];
      for (let i = 0; i < orig_data.length; i++) {
        var arr = [];
        var fund_name = orig_data[i]["fund_name"];
        var allocation = orig_data[i]["allocation"] * 1;

        arr[0] = fund_name;
        arr[1] = allocation;

        var iqcio_data_filter = iqcio_data.filter(
          d => d.fund_name == fund_name
        );

        if (iqcio_data_filter.length) {
          arr[2] = iqcio_data_filter[0]["fund_name"];
          arr[3] = iqcio_data_filter[0]["allocation"] * 1;
          // 		subtract from orig
          var sub = allocation - iqcio_data_filter[0]["allocation"] * 1;
          if (fund_name.toLowerCase() === "cash") {
            arr[4] = "";
          } else if (sub < 0) {
            arr[4] = `<span class="badge badge-success" style="font-weight:bold">Buy</span> ${Math.abs(
              sub.toFixed(1)
            )}%`;
          } else if (sub > 0) {
            arr[4] = `<span class="badge badge-pill badge-danger" style="font-weight:bold">Sell</span> ${sub.toFixed(
              1
            )}%`;
          } else {
            arr[4] = `<span class="badge badge-pill badge-secondary" style="font-weight:bold">Keep</span> ${sub.toFixed(
              1
            )}%`;
          }
        } else {
          arr[2] = "-";
          arr[3] = "-";
          // 		sell
          arr[4] = `<span class="badge badge-pill badge-danger" style="font-weight:bold">Sell</span> ${allocation *
            1}%`;
        }
        mergedData.push(arr);
      }
      for (let j = 0; j < iqcio_data.length; j++) {
        // default selected portfolio data
        var arr = [];
        var fund_name = iqcio_data[j]["fund_name"];
        var allocation = iqcio_data[j]["allocation"];

        var orig_data_filter = orig_data.filter(e => e.fund_name == fund_name);

        if (fund_name.toLowerCase() === "cash") {
          arr[4] = "";
        } else if (orig_data_filter.length == 0) {
          arr[0] = "-";
          arr[1] = "-";

          arr[2] = fund_name;
          arr[3] = allocation * 1;
          // 		buy
          arr[4] = `<span class="badge badge-success" style="font-weight:bold">Buy</span> ${allocation *
            1}%`;
          mergedData.push(arr);
        }
      }

      return mergedData;
    }
  },
  compareOrigAndIqcio_withoutTag: (orig_data, iqcio_data) => {
    
    if (orig_data && iqcio_data) {
      // orig data
      var mergedData = [];
      for (let i = 0; i < orig_data.length; i++) {
        var arr = [];
        var fund_name = orig_data[i]["fund_name"];
        var allocation = orig_data[i]["allocation"] * 1;

        arr[0] = fund_name;
        arr[1] = allocation;

        var iqcio_data_filter = iqcio_data.filter(
          d => d.fund_name == fund_name
        );

        if (iqcio_data_filter.length) {
          arr[2] = iqcio_data_filter[0]["fund_name"];
          arr[3] = iqcio_data_filter[0]["allocation"] * 1;
          // 		subtract from orig
          var sub = allocation - iqcio_data_filter[0]["allocation"] * 1;
          if (fund_name.toLowerCase() === "cash") {
            arr[4] = "";
          } else if (sub < 0) {
            arr[4] = `Buy ${Math.abs(
              sub.toFixed(1)
            )}%`;
          } else if (sub > 0) {
            arr[4] = `Sell ${sub.toFixed(
              1
            )}%`;
          } else {
            arr[4] = `Keep ${sub.toFixed(
              1
            )}%`;
          }
        } else {
          arr[2] = "-";
          arr[3] = "-";
          // 		sell
          arr[4] = `Sell ${allocation *
            1}%`;
        }
        mergedData.push(arr);
      }
      for (let j = 0; j < iqcio_data.length; j++) {
        // default selected portfolio data
        var arr = [];
        var fund_name = iqcio_data[j]["fund_name"];
        var allocation = iqcio_data[j]["allocation"];

        var orig_data_filter = orig_data.filter(e => e.fund_name == fund_name);

        if (fund_name.toLowerCase() === "cash") {
          arr[4] = "";
        } else if (orig_data_filter.length == 0) {
          arr[0] = "-";
          arr[1] = "-";

          arr[2] = fund_name;
          arr[3] = allocation * 1;
          // 		buy
          arr[4] = `Buy ${allocation *
            1}%`;
          mergedData.push(arr);
        }
      }

      return mergedData;
    }
  }
};

export default CompareHelper;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/compareORIG/compare.helper.js